"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionEventParametersBuilderImpl = void 0;
/**
 * Implementation of {@link SessionEventParametersBuilder}.
 *
 * @since 6.11
 */
var SessionEventParametersBuilderImpl = /** @class */ (function () {
    function SessionEventParametersBuilderImpl() {
        this.sessionEventParameters = {};
    }
    /**
     * @inheritdoc
     */
    SessionEventParametersBuilderImpl.prototype.filter = function (filter) {
        this.sessionEventParameters = __assign(__assign({}, this.sessionEventParameters), { filter: filter });
        return this;
    };
    /**
     * @inheritdoc
     */
    SessionEventParametersBuilderImpl.prototype.properties = function (properties) {
        var propertyArgs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            propertyArgs[_i - 1] = arguments[_i];
        }
        if (typeof properties === 'string') {
            properties = [properties].concat(propertyArgs);
        }
        this.sessionEventParameters = __assign(__assign({}, this.sessionEventParameters), { properties: new Set(properties) });
        return this;
    };
    SessionEventParametersBuilderImpl.prototype.after = function (time) {
        this.sessionEventParameters = __assign(__assign({}, this.sessionEventParameters), { after: time instanceof Date ? time.getTime() : time });
        return this;
    };
    /**
     * @inheritdoc
     */
    SessionEventParametersBuilderImpl.prototype.build = function () {
        return {
            filter: this.sessionEventParameters.filter,
            properties: this.sessionEventParameters.properties,
            after: this.sessionEventParameters.after
        };
    };
    return SessionEventParametersBuilderImpl;
}());
exports.SessionEventParametersBuilderImpl = SessionEventParametersBuilderImpl;
